import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "../core/utils";

// core
import { version } from "../core/config";
import { API } from "../core/api";

// store
import { Actions } from "../store/actions";

// components
import { Note } from "../components/Note";
import { Image, Button, Input } from "antd";

export const Login = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const store = useSelector((state) => state?.Store);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [captcha, setCaptcha] = useState("");
  const [captchaUUID, setCaptchaUUID] = useState("");
  const [captchaImg, setCaptchaImg] = useState("");

  const getCaptchaImage = () => {
    API.get
      .captcha()
      .then((response) => {
        if (response.success) {
          setCaptchaUUID(response.data.captcha_uuid);
          setCaptchaImg(response.data.image_str);
        } else {
          Note.error(response.message);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const login = () => {
    if (!username) {
      Note.error("لطفا نام کاربری خود را وارد کنید.");
      return;
    }
    if (!password) {
      Note.error("لطفا کلمه عبور خود را وارد کنید.");
      return;
    }
    if (!captcha) {
      Note.error("لطفا کد امنیتی را وارد کنید.");
      return;
    }

    API.post
      .login(username, password, captcha, captchaUUID)
      .then((response) => {
        if (response.success) {
          Note.success(response.message);
          dispatch(Actions.LoginUser(response.data));
          history.push("/");
        } else {
          Note.error(response.message);
          getCaptchaImage();
          setCaptcha("");
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  useState(() => {
    if (store.user?.is_login) {
      history.push("/");
    } else {
      getCaptchaImage();
    }
  }, []);

  return (
    <div className="login-page secondary-full-screen">
      <p className="font-size-header -mt-40">پنل مدیریت</p>
      <div className="form">
        <Input
          className="input-white border-white mb-15 text-center"
          prefix={<i className="far fa-user"></i>}
          allowClear={true}
          placeholder="نام کاربری"
          onChange={(e) => setUsername(e.target.value)}
          value={username}
        />
        <Input.Password
          className="input-white border-white mb-15 text-center"
          prefix={<i className="far fa-lock"></i>}
          allowClear={true}
          placeholder="کلمه عبور"
          onChange={(e) => setPassword(e.target.value)}
          value={password}
        />
        <Input
          className="input-white border-white text-center"
          prefix={<i className="far fa-robot"></i>}
          suffix={
            <Image
              className="captcha-image"
              onClick={() => getCaptchaImage()}
              src={captchaImg}
              preview={false}
              alt="captcha"
            />
          }
          allowClear={true}
          maxLength={4}
          placeholder="کد امنیتی"
          onChange={(e) => setCaptcha(e.target.value)}
          value={captcha}
        />
        <Button
          className="button-promotion mt-30 w-100"
          onClick={() => login()}>
          ورود
        </Button>
      </div>
      <small className="version">نسخه {version}</small>
    </div>
  );
};
